import { useEffect } from 'react'

/** Значение `--surface` (`tokens.css`): браузер не понимает переменные в `theme-color`. */
const SURFACE_HEX = '#14141a'

/**
 * Редактор на телефоне: полосы браузера и зоны у чёлки и индикатора — в цвет шапки, иначе над
 * ней и под лентой экранов остаются полосы темнее. Уход с экрана возвращает цвета страницы.
 */
export const useBrowserChromeColor = (active: boolean): void => {
  useEffect(() => {
    if (!active) return
    const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')
    const prevTheme = meta?.content
    const { documentElement: html, body } = document
    meta?.setAttribute('content', SURFACE_HEX)
    html.style.backgroundColor = SURFACE_HEX
    body.style.backgroundColor = SURFACE_HEX
    return () => {
      if (meta && prevTheme) meta.setAttribute('content', prevTheme)
      html.style.backgroundColor = ''
      body.style.backgroundColor = ''
    }
  }, [active])
}
